export default function MySQL_CHAR_LENGTH() {
  return (
    <div>
      <h2>MySQL_CHAR_LENGTH</h2>    </div>
  );
}